import { render } from "./tab-1.vue?vue&type=template&id=6c857846&scoped=true"
import script from "./tab-1.vue?vue&type=script&lang=js"
export * from "./tab-1.vue?vue&type=script&lang=js"

import "./tab-1.vue?vue&type=style&index=0&id=6c857846&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c857846"

export default script